import script from "./Verified.vue?vue&type=script&setup=true&lang=js"
export * from "./Verified.vue?vue&type=script&setup=true&lang=js"

import "./Verified.vue?vue&type=style&index=0&id=cb336906&lang=scss"

const __exports__ = script;

export default __exports__